function getReadableDescription () {
  if (!this.is_available) {
    // el ej tillgängligt
    return 'Elektricitet är ej tillgängligt'
  }
  if (this.is_included && this.is_included_season) {
    // ingår för både season och regular
    return 'Elektricitet ingår i priset'
  }
  if (!this.is_included && !this.is_included_season) {
    // ingår inte för varken season eller regular
    let text = ''
    if (this.daily_price && this.meter_price) {
      text += `Elektricitet är tillgängligt för ${this.daily_price / 100}kr / dag och ${this.meter_price / 100}kr / KWh för rörliga bokningar`
    } else if (this.daily_price) {
      text += `Elektricitet är tillgängligt för ${this.daily_price / 100}kr / dag för rörliga bokningar`
    } else if (this.meter_price) {
      text += `Elektricitet är tillgängligt för ${this.meter_price / 100}kr / KWh för rörliga bokningar`
    } else {
      text += 'Elektricitet är tillgängligt, pris är ej angivet för rörliga bokningar'
    }

    // endast mätarpris för säsongsbokningar
    if (this.season_meter_price) {
      text += ` och ${this.season_meter_price / 100}kr / KWh för säsongsbokningar`
    } else {
      text += ', pris är ej angivet för säsongsbokningar'
    }
    return text
  }

  if (this.is_included) {
    // ingår för regular men inte season
    if (this.season_meter_price) {
      return `Elektricitet ingår för rörliga bokningar och finns tillgängligt för ${this.season_meter_price / 100}kr / KWh för säsongsbokningar`
    }
    return 'Elektricitet ingår för rörliga bokningar och finns tillgängligt för säsongsbokningar men pris är ej angivet'
  } else {
    // ingår för season men inte regular
    if (this.daily_price && this.meter_price) {
      return `Elektricitet ingår för säsongsbokningar och finns tillgängligt för ${this.daily_price / 100}kr / dag och ${this.meter_price / 100}kr / KWh för rörliga bokningar`
    } else if (this.daily_price) {
      return `Elektricitet ingår för säsongsbokningar och finns tillgängligt för ${this.daily_price / 100}kr / dag för rörliga bokningar`
    } else if (this.meter_price) {
      return `Elektricitet ingår för säsongsbokningar och finns tillgängligt för ${this.meter_price / 100}kr / KWh för rörliga bokningar`
    }
    return 'Elektricitet ingår för säsongsbokningar och finns tillgängligt för rörliga bokningar men pris är ej angivet'
  }
}

export default {
  getReadableDescription
}
